import { useMemo } from "react";
import { useAchievements } from "@/features/settings/viewModal/useAchievements";

export const useSettingsHistoricalAchievementsViewModel = () => {
  const achievements = useAchievements();

  const displaySavings = useMemo(() => {
    return achievements.totalSavings > 0 ? `$${achievements.formattedSavings}` : "No savings yet";
  }, [achievements.totalSavings, achievements.formattedSavings]);

  return {
    ...achievements,
    displaySavings,
  };
};
